import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import { VisionIcon, MissionIcon } from './Icons';
import './Vision.css';

const Vision = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="vision" className="vision">
      <div className="container">
        <div className="vision-mission-grid">
          <div className="vision-card">
            <div className="vision-icon">
              <VisionIcon />
            </div>
            <h3>{t.vision}</h3>
            <p>{t.visionText}</p>
          </div>
          
          <div className="mission-card">
            <div className="mission-icon">
              <MissionIcon />
            </div>
            <h3>{t.mission}</h3>
            <p>{t.missionText}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;
